module.exports = __webpack_public_path__ + "img/empty.7688d83f.png";